export const truckSearchOptions = [
  { value: 'code', label: 'Truck code' },
  { value: 'title', label: 'title' },
  { value: 'bedLengthInFt', label: 'Bed Length' },
]
